import { useLayoutEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { Reveal } from "./Motion";

const StepCard = ({ step, i }) => (
  <div data-testid={`method-step-${i}`} className="relative flex h-[62vh] min-h-[380px] w-[82vw] shrink-0 flex-col justify-between rounded-[32px] border border-black/10 bg-[#fafaf7] p-8 md:w-[36vw] md:p-12">
    <span className="font-serif-i gold-text text-[7rem] leading-none md:text-[10rem]">{i + 1}</span>
    <div>
      <div className="mb-6 h-px w-16 bg-[#d4af37]" />
      <h3 className="font-display text-3xl font-bold tracking-tight md:text-5xl">{step.title}</h3>
      <p className="mt-4 max-w-sm text-base leading-relaxed text-black/60">{step.desc}</p>
    </div>
  </div>
);

export const Method = () => {
  const { t } = useLang();
  const m = t.method;
  const section = useRef(null);
  const track = useRef(null);
  const [dist, setDist] = useState(0);
  const { scrollYProgress } = useScroll({ target: section, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], [0, -dist]);
  const bar = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  useLayoutEffect(() => {
    const measure = () => setDist(Math.max(0, track.current.scrollWidth - window.innerWidth));
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [t]);

  return (
    <section id="metodo" ref={section} data-testid="method-section" className="relative bg-[#f3efe6] text-[#0a0a0b]" style={{ height: `calc(100vh + ${dist}px)` }}>
      <div className="sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
        <motion.div ref={track} style={{ x }} className="flex items-center gap-6 pl-6 pr-6 md:gap-8 md:pl-14 md:pr-14">
          <div className="flex w-[82vw] shrink-0 flex-col justify-center md:w-[34vw]">
            <Reveal>
              <p className="eyebrow mb-8" style={{ color: "#8c6b1f" }}>{m.eyebrow}</p>
              <h2 className="font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-6xl">{m.title}</h2>
              <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.3em] text-black/40">{m.hint} →</p>
            </Reveal>
          </div>
          {m.steps.map((s, i) => <StepCard key={s.title} step={s} i={i} />)}
        </motion.div>
        <div className="wrap mt-10">
          <div className="h-px w-full bg-black/10">
            <motion.div style={{ width: bar }} className="h-px bg-[#8c6b1f]" />
          </div>
        </div>
      </div>
    </section>
  );
};
